module.exports = __webpack_public_path__ + "static/img/vn.e431e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/footer_icon/vn.png
// module id = ZJe1
// module chunks = 0